import React from "react"
import { Link } from "gatsby"
import { graphql } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"
import Sidebar from "../components/sidebar"

import { faSkiing } from "@fortawesome/free-solid-svg-icons"
import { faChild } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

const SecondPage = ({ data }) => (
  <Layout>
    <SEO
      title={data.wpgraphql.page.title}
      description={data.wpgraphql.page.title}
    />

    {data.wpgraphql.page.featuredImage && (
      <div className="hero-banner flex bg-gray-700">
        <div
          className="w-1/3 lg:w-1/2 p-2 lg:p-8"
          data-sal="slide-right"
          data-sal-delay="300"
          data-sal-easing="ease"
        >
          <h1
            className="text-white"
            dangerouslySetInnerHTML={{ __html: data.wpgraphql.page.title }}
          />
          {data.wpgraphql.page.acfDesc.description && (
            <p
              className="program-description text-white"
              dangerouslySetInnerHTML={{
                __html: data.wpgraphql.page.acfDesc.description
              }}
            />
          )}
          {data.wpgraphql.page.acfDesc.coachprogram && (
            <div className="program-nav">
              <div className="icon">
                <FontAwesomeIcon icon={faChild} className="icon-class" />
              </div>
              <span className="id font-sans">Coach Training</span>
              <h4
                className="program-title"
                dangerouslySetInnerHTML={{
                  __html: data.wpgraphql.page.acfDesc.coachprogram
                }}
              />
            </div>
          )}
          {data.wpgraphql.page.acfDesc.athleteprogram && (
            <div className="program-nav">
              <div className="icon">
                <FontAwesomeIcon icon={faSkiing} className="icon-class" />
              </div>
              <span className="id font-sans">Athlete Program</span>
              <h4
                className="program-title"
                dangerouslySetInnerHTML={{
                  __html: data.wpgraphql.page.acfDesc.athleteprogram
                }}
              />
            </div>
          )}
        </div>
        <div class="bg-gray-400 w-full lg:w-1/2 relative pt-2/3 lg:pt-1/3">
          <img
            className="object-cover w-full h-full absolute inset-y-0"
            src={data.wpgraphql.page.featuredImage.mediaItemUrl}
            alt={data.wpgraphql.page.title}
          />
        </div>
      </div>
    )}
    <div
      className={
        "page-content p-8 lg:p-12 container mx-auto flex id-" +
        data.wpgraphql.page.databaseId
      }
    >
      <article className="w-full lg:w-2/3 lg:pr-12">
        <div
          dangerouslySetInnerHTML={{ __html: data.wpgraphql.page.content }}
        />

        <Link to="/">Go back to the homepage</Link>
      </article>
      <Sidebar />
    </div>
  </Layout>
)

export default SecondPage

export const query = graphql`
  query($databaseId: ID!) {
    wpgraphql {
      page(id: $databaseId, idType: DATABASE_ID) {
        title
        date
        content(format: RENDERED)
        databaseId
        acfDesc {
          athleteprogram
          coachprogram
          description
        }
        featuredImage {
          altText
          title(format: RENDERED)
          mediaItemUrl
          slug
        }
      }
    }
  }
`
